import _ from "lodash"
import Cookies from 'js-cookie'
//************************************//
import { API, API_WithSwal } from '../../utility/API'
import { _changeAppLang, _getAppLang, _setAPIToken } from '@utils'

//************************************//
export const _login = (data, callback, callbackErr = () => { }) => {
  API.post('/Auth/Login', data)
    .then(function (res) {
      callback(res)
    })
    .catch(function (res) {
      callbackErr(res)
    })
}
//************************************//
export const _setUserToken = (json) => {
  const token = JSON.stringify(json)
  sessionStorage.setItem("USER_TOKEN", token)
  Cookies.set("USER_TOKEN", token)
  if (json.user.locale && json.user.locale !== _getAppLang()) {
    _changeAppLang(json.user.locale)
  }
}
//************************************//
export const _removeUserToken = () => {
  sessionStorage.removeItem("USER_TOKEN")
  localStorage.removeItem("USER_TOKEN")
  Cookies.remove("USER_TOKEN")
}
//************************************//
export const _autoLogin = (dispatch, ability, callback) => {
  const storageUserToken = JSON.parse(localStorage.getItem('USER_TOKEN'))
  const cookieUserToken = Cookies.get('USER_TOKEN') ? JSON.parse(Cookies.get('USER_TOKEN')) : false
  const storedUser = (cookieUserToken || storageUserToken || false)
  if (storedUser && storedUser.token && storedUser.user) {
    API.post('/Auth/check-login', { loginToken: storedUser.token, stayOnline: true })
      .then(function ({ data }) {
        const user = data
        if (user.id) {
          _setUserToken({ ...storedUser, ...user })
          _setAPIToken(user.token)
          dispatch({ type: "USER_LOGIN", userData: { ...storedUser, ...user }, token: user.token })
          if (data?.facultyId) {
            ability.update([
              {
                subject: 'FACULTY_ADMIN',
                action: 'call'
              }
            ])
          } else {
            ability.update([
              {
                subject: 'all',
                action: 'manage'
              }
            ])
          }
          callback()
        }
      })
      .catch(function (res) {
        _removeUserToken()
        callback()
      })
  } else {
    callback()
  }
}

//***************** Users *******************//
export const _addUser = (data, callback, callbackErr = () => { }) => {
  API_WithSwal.post(`/User/Create`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
}
//************************************//
export const _editUser = (data, callback, callbackErr = () => { }) => {
  API_WithSwal.put(`/User/Update`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
}
//************************************//
export const _deleteUser = (id, callback) => {
  API_WithSwal.delete(`/User/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
    })
}
//************************************//
export const _setUserActiveStatus = (id, callback) => {
  API_WithSwal.patch(`/User/${id}/SetActive`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
    })
}

//***************** Responsibles *******************//
export const _getResponsible = (id, callback, callbackErr = () => { }) => {
  API.get(`/Managment/ReadUser?filter=id~eq~'${id}'`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      // callbackErr(data.errors)
    })
}
//************************************//
export const _deleteResponsible = (id, callback) => {
  API.delete(`/Users/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
    })
}
//************************************//
export const _activateTeamMember = (id, callback) => {
  API.delete(`responsible/activateTeamMember/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
    })
}
//************************************//
export const _deactivateTeamMember = (id, callback) => {
  API.delete(`responsible/deActivateTeamMember/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
    })
}
//************************************//
export const _getAllResponsiblesWithQ = async (q = '') => {
  const { data } = await API.get('responsible/getAllResponsiblesWithQ', {
    params: {
      limit: 20,
      q
    }
  })
  return _.map(data.responsibles, (v, k) => {
    return { value: v.id, label: `${v.fname} ${v.mname} ${v.lname}` }
  })
}
//***************** Notifications *******************//
export const _sendPushNotification = (data, callback, callbackErr = () => { }) => {
  API_WithSwal.post(`/notifications`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
}
//************************************//
export const _getAllAdminsWithQ = async (q = '') => {
  const { data } = await API.get('admin/getAllAdminsWithQ', {
    params: {
      limit: 20,
      q
    }
  })
  return _.map(data.municipalities, (v, k) => {
    return { value: v.id, label: v.name }
  })
}
//************************************//
export const _getAllRolesWithQ = async (q = '') => {
  const { data } = await API.get('getAllRolesWithQ', {
    params: {
      limit: 20,
      q
    }
  })
  return _.map(data.roles, (v, k) => {
    return { value: v.id, label: v.name.replace("_", " ") }
  })
}
//************************************//
export const _getAllRoles = (callback = () => { }) => {
  API.get('Role/Read')
    .then((data) => {
      callback(data)
    })
}
//************************************//
export const _loginTwoFactor = ({ email, code }, callback, callbackErr = () => { }) => {
  API.post('/login-2fa', { email, code })
    .then(function (res) {
      callback(res)
    })
    .catch(function ({ data }) {
      callbackErr(data)
    })
}
//************************************//
export const _register = ({ firstName, lastName, email }, callback, callbackErr = () => { }) => {
  API.post('/register', { first_name: firstName, last_name: lastName, email })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      callbackErr(data.data)
    })
}
//************************************//
export const _forgetPassword = ({ email }, callback, callbackErr = () => { }) => {
  API.post('/forget-password', { email })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      callbackErr(data.data)
    })
}
//************************************//
export const _resetPassword = ({ email, currentPassword, newPassword }, callback, callbackErr = () => { }) => {
  API.post('/reset-password', { email, current_password: currentPassword, new_password: newPassword })
    .then(function (res) {
      callback(res)
    })
    .catch(function ({ data }) {
      callbackErr(data.data)
    })
}
//************************************//
export const _changePassword = (data, callback, callbackErr = () => { }) => {
  API.post('/user/account/change-password', { ...data })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      callbackErr(data.data)
    })
}
//************************************//
export const _logout = () => {
  return dispatch => {
    // ** Remove user, accessToken & refreshToken from storages
    _removeUserToken()
    _setAPIToken('')
    dispatch({ type: 'USER_LOGOUT' })
  }
}
//************************************//
export const _getMyProfile = (dispatch) => {
  API.get('/user/account/my-profile')
    .then(function ({ data }) {
      const userToken = JSON.parse(sessionStorage.getItem('USER_TOKEN'))
      userToken.user = { ...userToken.user, ...data.basic_info }
      sessionStorage.setItem("USER_TOKEN", JSON.stringify(userToken))
      dispatch({ type: 'USER_MY_PROFILE', data })
    })
    .catch(function (res) { })
}
//************************************//
export const _changeBasicInfo = (data, callback, callbackErr = () => { }) => {
  return dispatch => {
    API.post('/user/account/change-basic-info', data)
      .then(function ({ data }) {
        _getMyProfile(dispatch)
      })
      .catch(function ({ data }) {
        callbackErr(data.data)
      })
  }

}
//************************************//
export const _changeGeneralInfo = (data, callback, callbackErr = () => { }) => {
  return dispatch => {
    API.post('/user/account/change-general-info', { ...data })
      .then(function ({ data }) {
        _getMyProfile(dispatch)
      })
      .catch(function ({ data }) {
        callbackErr(data.data)
      })
  }

}
//************************************//
export const _saveSupportEmail = (data, callback, callbackErr = () => { }) => {
  API.post('support/store', { ...data })
    .then(function ({ data }) {
    })
    .catch(function ({ data }) {
      callbackErr(data.data)
    })

}


//********************************** File manager ************************************//
//***************** Get files *******************//
export const _getFileManagerData = (parentId, callback, callbackErr = () => { }, callbackFinally = () => { }) => {
  API.get(`/FileManager/Read?filter=parentId~eq~'${parentId}'`)
    // API.get(`/FileManager/Read`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
    .finally(() => {
      callbackFinally()
    })
}
//***************** Get file by id *******************//
export const _getFileManagerItemData = (id, callback, callbackErr = () => { }, callbackFinally = () => { }) => {
  API.get(`/FileManager/Read?filter=id~eq~'${id}'`)
    // API.get(`/FileManager/Read`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
    .finally(() => {
      callbackFinally()
    })
}
//***************** Create new *******************//
export const _storeFileManagerItem = (data, callback, callbackErr = () => { }, callbackFinally = () => { }) => {
  API.post(`/FileManager/Create`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
    .finally(() => {
      callbackFinally()
    })
}
//***************** Update file name *******************//
export const _updateFileManagerItemTitle = (data, callback, callbackErr = () => { }, callbackFinally = () => { }) => {
  API.put(`/FileManager/Update`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
    .finally(() => {
      callbackFinally()
    })
}
//***************** Delete file name *******************//
export const _deleteFileManagerItem = (id, callback, callbackErr = () => { }, callbackFinally = () => { }) => {
  API.delete(`/FileManager/Delete?id=${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (data) {
      callbackErr(data?.data?.errors)
    })
    .finally(() => {
      callbackFinally()
    })
}
